module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gtj",
    attrs: {
      "id": "pay"
    }
  }, [_c('div', {
    staticClass: "pay_main"
  }, [_c('div', {
    staticClass: "successBg"
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }, [_vm._v("等待支付")]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.desc)
    }
  }, [_vm._v("或支付被取消，請重新支付。")]), _vm._v(" "), _c('div', {
    staticClass: "apply_btn",
    on: {
      "click": _vm.callPay
    }
  }, [_vm._v("重新支付")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47614d8c","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Pay.vue
// module id = 321
// module chunks = 1